import { Icon } from '@iconify/react/dist/iconify.js';
import { Box, Checkbox, FormControl, FormHelperText, FormLabel, MenuItem, Select } from '@mui/material';
import Helpers from '../../helpers/helpers';
import { useEffect, useState } from 'react';


export default function CustomSelectMultiple2({
    values, onChange, error, data, title, required, disabled, placeholder, subtitle, name, valueName, labelName, width, module
}) {
    const [all, setAll] = useState(false);

    // Keep `all` in sync with `values` (if values length equals data length -> all selected)
    useEffect(() => {
        const key = valueName || 'value';
        const allValues = (data || []).map(item => item[key]);
        const allSelected = allValues.length > 0 && values?.length === allValues.length;
        setAll(allSelected);
    }, [values, data, valueName]);

    const handleOnChange = (event) => {
        let selected = event.target.value || [];

        const key = valueName || 'value';
        const allValues = (data || []).map(item => item[key]);

        // determine type from first value
        const isNumber = allValues.length > 0 && typeof allValues[0] === 'number';

        // If 'all' sentinel is present -> toggle select all / clear
        const includesAll = selected.includes('all');
        if (includesAll) {
            if ((values || []).length !== allValues.length) {
                onChange(allValues);
            } else {
                onChange([]);
            }
            return;
        }

        // Normalize types to match allValues (numbers vs strings)
        const normalized = selected.map(v => (isNumber ? Number(v) : v));
        onChange(normalized);
    };

    return (
        <>
            <FormControl variant="outlined" fullWidth>
                <Select
                    size="small"
                    value={values}
                    name={name}
                    required={required}
                    disabled={disabled}
                    multiple
                    displayEmpty
                    disableUnderline
                    placeholder={placeholder || 'Choose'}
                    onChange={handleOnChange}
                    style={{ color: (values === "" || values === "-1") && "#c8c8c8", height: 33, backgroundColor: 'white', borderRadius: 15, padding: 0, }}
                    sx={{
                        '& .MuiFilledInput-input': {
                            borderRadius: 10,
                            backgroundColor: 'white',
                            padding: 0,
                            paddingInline: 2
                        },
                    }}
                    IconComponent={() => (
                        <i className="ri-expand-up-down-line mx-2" style={{ zIndex: 2 }} />
                    )}
                    renderValue={(selected) => (
                        <Box sx={{ display: 'flex', gap: 0.5, marginLeft: 1 }} onClick={(e) => e.stopPropagation()}>
                            {values?.length > 0 ? `${values?.length} selected` : (
                                <span>
                                    {placeholder}
                                </span>
                            )}
                        </Box>
                    )}
                >
                    {/* "All" menu item uses sentinel value 'all' */}
                    <MenuItem key={'all'} value={'all'}>
                        <Checkbox
                            checked={all}
                            sx={{
                                '&.Mui-checked': { color: "#ED1A3D" },
                                '& .MuiSvgIcon-root': { fontSize: 18 },
                            }}
                        // no onChange here - Select onChange will handle selection array
                        />
                        All {module}
                    </MenuItem>
                    {
                        data && data.length > 0 && data.map((x, idx) =>
                            <MenuItem className='d-flex align-items-center' key={idx} value={x[`${valueName}`] || x?.id || x?.value} style={{ backgroundColor: (x?.value || x?.id) === values ? '#FEC00A' : 'white', }}>
                                <Checkbox
                                    checked={values?.some(v => String(v) === String(x[`${valueName}`] || x?.id || x?.value)) || false}
                                    sx={{
                                        '&.Mui-checked': { color: "#ED1A3D" },
                                        '& .MuiSvgIcon-root': { fontSize: 18 },
                                    }}
                                // no onChange here - Select handles the array of selected values
                                />
                                {x?.[`${labelName}`] || x?.name || x?.label}
                            </MenuItem>
                        )
                    }
                </Select>
                {subtitle && <span style={{ fontSize: 13, color: '#74788D', marginTop: '5px', fontWeight: '300' }}>{subtitle}</span>}
            </FormControl >
            {error && <FormHelperText sx={{ color: "#BA2727" }}><Icon icon={'fluent:error-circle-24-filled'} height={16} width={16} />{error || ""}</FormHelperText>
            }

        </>


    );
}